import DEVICE_MODE_WIDTHS from '../constants/device-mode-widths';

const getDeviceModeWidth = (deviceMode) => DEVICE_MODE_WIDTHS[deviceMode] || null;

export default getDeviceModeWidth;
